module.exports = __webpack_public_path__ + "static/img/pinpai-15.35af7d49.png";